module.exports = __webpack_public_path__ + "img/en.dabf6c06.png";